var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h5',[_vm._v("File type specific items ")]),_c('div',_vm._l((_vm.getCurrentFields),function(field){return _c('input-widget',{attrs:{"id":`flat-file-${field.name}`,"model":_vm.formFromStore,"field":field}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }